import { css } from 'linaria';
import { usePopover, popoverBase } from 'components/popover/popover';
import { OverflowMenuIcon } from 'components/icons/OverflowMenuIcon';
import PropTypes from 'prop-types';
import { menuItemStyle } from './base';
export const popoverContainer = "paazj57";
const popoverMenuItem = "p8t2qn2";

const PopoverMenuItem = ({
  item: {
    label,
    icon,
    onClick
  }
}) => {
  return <div data-cy={label} className={popoverMenuItem} onClick={onClick}>
      {icon ? icon : null}
      {label}
    </div>;
};

const MenuPopover = function ({
  popoverRef,
  menuItems
}) {
  return <div className={popoverContainer} ref={popoverRef}>
      {menuItems.map(item => <PopoverMenuItem item={item} key={item.label} />)}
    </div>;
};

export const OverflowAction = function ({
  toggleLabel,
  menuItems,
  placement
}) {
  const handleClick = event => {
    event.preventDefault();
    event.stopPropagation();
  }; // Popover Effect


  const {
    popTrigger,
    popBody,
    shown
  } = usePopover({
    placement,
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 0]
      }
    }]
  });
  return <>
      <button data-cy="overflow" className={menuItemStyle} onClick={handleClick} ref={popTrigger}>
        <OverflowMenuIcon />
        {toggleLabel ? <div className="actionCopy">{toggleLabel}</div> : null}
      </button>
      {shown ? <MenuPopover popoverRef={popBody} menuItems={menuItems} /> : null}
    </>;
};
OverflowAction.propTypes = {
  toggleButton: PropTypes.object,
  toggleLabel: PropTypes.string,
  // https://popper.js.org/docs/v2/constructors/#placement
  placement: PropTypes.oneOf(['auto', 'auto-start', 'auto-end', 'top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'right', 'right-start', 'right-end', 'left', 'left-start', 'left-end']),
  alignRight: PropTypes.bool
};
OverflowAction.defaultProps = {
  toggleLabel: '',
  placement: 'top-end',
  alignRight: false
};

require("./overflow.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./overflow.js");